import { render, staticRenderFns } from "./trantimeconfig.vue?vue&type=template&id=56b2c04c&scoped=true&"
import script from "./trantimeconfig.vue?vue&type=script&lang=js&"
export * from "./trantimeconfig.vue?vue&type=script&lang=js&"
import style0 from "./trantimeconfig.vue?vue&type=style&index=0&id=56b2c04c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b2c04c",
  null
  
)

export default component.exports